const { Fragment, useState, useRef, useEffect } = wp.element;
const { PanelBody, PanelRow, Button, __experimentalNumberControl: NumberControl, TextControl, FormToggle, SelectControl, TextareaControl, ButtonGroup, __experimentalUnitControl: UnitControl } = wp.components;
const { __ } = wp.i18n;

import BMediaUpload from "../../BMediaUpload";

const Settings = ({ attributes, setAttributes }) => {
  const { autoplay, autoplayWhenVisible, source, poster, repeat, ratio, muted, seekTime, startTime, library, autoHideControl, resetOnEnd, disablePause, thumbInPause, protected: bProtected, password, protectedText, sticky, stickyPosition, hideYoutubeUI, vastTag, CDURL, preload, isCDURL, thumbStyle, playsinline } = attributes;

  return (
    <PanelBody title={__("Settings", "h5vp")} initialOpen={false}>
      <BMediaUpload
        type={["video"]}
        onSelect={(source) => {
          if (source.split(".").pop() === "m3u8") {
            setAttributes({ streamingType: "hls", streaming: true, source });
          } else if (source.split(".").pop() === "mpd") {
            setAttributes({ streamingType: "dash", streaming: true, source });
          } else {
            setAttributes({ streaming: false, source });
          }
        }}
        value={source}
        plceholder="video source"
      />
      <BMediaUpload
        type={["image"]}
        onSelect={(poster) => {
          setAttributes({ poster });
        }}
        value={poster}
        placeholder="video Thumbnails"
      />
      <PanelRow>
        <label htmlFor="isCDURL" className="label">
          {__("Custom Downlaod URL?", "h5vp")}
        </label>
        <FormToggle id="isCDURL" checked={isCDURL} onChange={() => setAttributes({ isCDURL: !isCDURL })} />
      </PanelRow>
      {isCDURL && (
        // <PanelRow className="inline">
        <TextControl value={CDURL} onChange={(CDURL) => setAttributes({ CDURL })} />
        // </PanelRow>
      )}
      <PanelRow>
        <label htmlFor="repeat" className="label">
          {__("Repeat", "h5vp")}
        </label>
        <FormToggle id="repeat" checked={repeat} onChange={() => setAttributes({ repeat: !repeat })} />
      </PanelRow>
      <PanelRow>
        <label htmlFor="autoplay" className="label">
          {__("Autoplay", "h5vp")}
        </label>
        <FormToggle id="autoplay" checked={autoplay} onChange={() => setAttributes({ autoplay: !autoplay })} />
      </PanelRow>
      <PanelRow>
        <label htmlFor="autoplayWhenVisible" className="label">
          {__("Autoplay When Visible on Screen", "h5vp")}
        </label>
        <FormToggle id="autoplayWhenVisible" checked={autoplayWhenVisible} onChange={() => setAttributes({ autoplayWhenVisible: !autoplayWhenVisible })} />
      </PanelRow>
      <PanelRow>
        <label htmlFor="muted" className="label">
          {__("Muted", "h5vp")}
        </label>
        <FormToggle id="muted" checked={muted} onChange={() => setAttributes({ muted: !muted })} />
      </PanelRow>
      <PanelRow>
        <label htmlFor="sticky" className="label">
          {__("Sticky On Scroll", "h5vp")}
        </label>
        <FormToggle id="sticky" checked={sticky} onChange={() => setAttributes({ sticky: !sticky })} />
      </PanelRow>
      {sticky && (
        <PanelRow className="stickyPosition">
          <label htmlFor="stickyPosition" className="label">
            {__("Sticky Position", "h5vp")}
          </label>
          <SelectControl
            value={stickyPosition}
            options={[
              { label: "Top Right", value: "top-right" },
              { label: "Bottom Right", value: "bottom-right" },
            ]}
            onChange={(stickyPosition) => {
              setAttributes({ stickyPosition });
            }}
          />
        </PanelRow>
      )}
      <PanelRow>
        <label htmlFor="disablePause" className="label">
          {__("Disable Pause", "h5vp")}
        </label>
        <FormToggle id="disablePause" checked={disablePause} onChange={() => setAttributes({ disablePause: !disablePause })} />
      </PanelRow>
      <PanelRow>
        <label htmlFor="thumbInPause" className="label">
          {__("Show thumbnail on pause", "h5vp")}
        </label>
        <FormToggle id="thumbInPause" checked={thumbInPause} onChange={() => setAttributes({ thumbInPause: !thumbInPause })} />
      </PanelRow>
      {thumbInPause && poster && (
        <PanelRow>
          <label htmlFor="thumbInPause" className="label">
            {__("Thumb Style", "h5vp")}
          </label>
          <ButtonGroup>
            <Button onClick={() => setAttributes({ thumbStyle: "default" })} className={`button ${thumbStyle == "default" ? "button-primary" : ""}`}>
              {__("Default", "h5vp")}
            </Button>
            <Button onClick={() => setAttributes({ thumbStyle: "custom" })} className={`button ${thumbStyle == "custom" ? "button-primary" : ""}`}>
              {__("Custom", "h5vp")}
            </Button>
          </ButtonGroup>
        </PanelRow>
      )}
      {!repeat && (
        <PanelRow>
          <label htmlFor="resetOnEnd" className="label">
            {__("Reset On End", "h5vp")}
          </label>
          <FormToggle id="resetOnEnd" checked={resetOnEnd} onChange={() => setAttributes({ resetOnEnd: !resetOnEnd })} />
        </PanelRow>
      )}
      <PanelRow>
        <label htmlFor="autoHideControl" className="label">
          {__("Auto Hide Control", "h5vp")}
        </label>
        <FormToggle id="autoHideControl" checked={autoHideControl} onChange={() => setAttributes({ autoHideControl: !autoHideControl })} />
      </PanelRow>
      <PanelRow>
        <label htmlFor="playsinline" className="label">
          {__("Play Inline (iOS)", "h5vp")}
        </label>
        <FormToggle checked={playsinline} onChange={() => setAttributes({ playsinline: !playsinline })} />
      </PanelRow>
      <PanelRow>
        <label htmlFor="playsinline" className="label">
          {__("Play Inline (iOS)", "h5vp")}
        </label>
        <FormToggle checked={playsinline} onChange={() => setAttributes({ playsinline: !playsinline })} />
      </PanelRow>
      {/* <span>{__("Allow inline playback on iOS.", "h5vp")}</span> */}
      <PanelRow>
        <label className="label">{__("Seek Time", "h5vp")}</label>
        <NumberControl isShiftStepEnabled={true} onChange={(seekTime) => setAttributes({ seekTime: parseInt(seekTime) })} shiftStep={1} value={seekTime} />
      </PanelRow>
      <PanelRow>
        <label className="label">{__("Start Time", "h5vp")}</label>
        <NumberControl isShiftStepEnabled={true} onChange={(startTime) => setAttributes({ startTime: parseFloat(startTime) })} shiftStep={1} step={0.1} value={parseFloat(startTime)} />
      </PanelRow>
      <PanelRow>
        <label className="label">{__("Video Ratio", "h5vp")}</label>
        <TextControl onChange={(ratio) => setAttributes({ ratio })} value={ratio} placeholder={"16:9"} />
      </PanelRow>
      <PanelRow>
        <label className="label">{__("Preload", "h5vp")}</label>
      </PanelRow>
      <SelectControl
        value={preload}
        options={[
          { label: "none", value: "none" },
          { label: "metadata", value: "metadata" },
          { label: "auto", value: "auto" },
        ]}
        onChange={(preload) => {
          setAttributes({ preload });
        }}
      />
      <PanelRow>
        <label htmlFor="bProtected" className="label">
          {__("Password Protected", "h5vp")}
        </label>
        <FormToggle id="bProtected" checked={bProtected} onChange={() => setAttributes({ protected: !bProtected })} />
      </PanelRow>
      {bProtected && (
        <Fragment>
          <PanelRow className="inline">
            <label htmlFor="" className="label">
              {__("Password", "h5vp")}
            </label>
            <TextControl value={password} onChange={(password) => setAttributes({ password })} />
          </PanelRow>
          <PanelRow>
            <label htmlFor="" className="label">
              {__("Protected Text", "h5vp")}
            </label>
          </PanelRow>
          <PanelRow className="width-100">
            <TextareaControl value={protectedText} onChange={(protectedText) => setAttributes({ protectedText })} />
          </PanelRow>
        </Fragment>
      )}
      {/* <PanelRow>
                          <label htmlFor="saveState" className="label">
                            {__("Save State", "h5vp")}
                          </label>
                          <FormToggle id="saveState" checked={saveState} onChange={() => setAttributes({ saveState: !saveState })} />
                        </PanelRow> */}
      <PanelRow>
        <label htmlFor="vastTag" className="label">
          {__("Google VAST TagURL", "h5vp")}
        </label>
      </PanelRow>
      <TextareaControl id="vastTag" value={vastTag} onChange={(vastTag) => setAttributes({ vastTag })} />

      {library === "youtube" && (
        <PanelRow>
          <label className="label" htmlFor="hideYoutubeUI">
            {__("Hide Youtube UI (Experimental, check it's working or not for you)", "h5vp")}
          </label>
          <FormToggle id="hideYoutubeUI" checked={hideYoutubeUI} onChange={() => setAttributes({ hideYoutubeUI: !hideYoutubeUI })} />
        </PanelRow>
      )}
    </PanelBody>
  );
};

export default Settings;
